import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';

@Component({
  selector: 'app-inventory-item',
  templateUrl: './inventory-item.component.html',
  styleUrls: ['./inventory-item.component.css']
})
export class InventoryItemComponent implements OnInit {

  constructor(private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  ItemModel = {
    ItemID:0,
    InventoryCategoryID: 0,
    ItemCategoryID: 0,
    ItemCode: '',
    ItemName: '',
    BrandName: '',
    ModelName:'',
    Description:'',
    IsActive: true,
    PurchasePrice: 0,
    AvailableQty: 0,
    OpenningQty:0,
    SalePrice: 0,
    MinQty: 0,
    MaxQty: 0,
    PageSize: 0,


}

currentPage = 1;
pageSize = 20;
recordCount = 0;
totalPages = 0;
numberOfPages  () {

    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
}

nextPage  () {
    this.currentPage = this.currentPage + 1;

}

pageSizes  () {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;

}
FilterModel = {
    CurrentIndex: 0,
    PageSize: 20,
    InventoryCategoryID: 0,
    ItemCategoryID: 0,
    ItemCode: '',
    ItemName: '',
}
Clear  () {
    this.ItemModel.ItemID = 0;
    this.ItemModel.InventoryCategoryID = 0;
    this.ItemModel.ItemCategoryID = 0;
    this.ItemModel.SalePrice = 0;
    this.ItemModel.PurchasePrice = 0;
    this.ItemModel.MinQty = 0;
    this.ItemModel.AvailableQty = 0;
    this.ItemModel.OpenningQty =0;
    this.ItemModel.MaxQty = 0;
    this.ItemModel.ItemCode = '';
    this.ItemModel.ItemName = '';
    this.ItemModel.Description = '';
    this.ItemModel.BrandName = '';
    this.ItemModel.ModelName = '';
    this.ItemModel.IsActive = true;
    this.Submitted = false;
}
Submitted = false;
ClearSearch  () {
    this.FilterModel.InventoryCategoryID = 0;
    this.FilterModel.ItemCategoryID = 0;
    this.FilterModel.ItemCode = '';
    this.FilterModel.ItemName = '';       
}
Edit  (obj) {
    this.ItemModel.ItemID = obj.ItemID;
    this.ItemModel.InventoryCategoryID = obj.InventoryCategoryID;
    this.ItemModel.ItemName = obj.ItemName;
    this.ItemModel.Description = obj.Description;
    this.ItemModel.ItemCode = obj.ItemCode;
    this.ItemModel.BrandName = obj.BrandName;
    this.ItemModel.ModelName = obj.ModelName;
    this.BindInventoryItemCategory();
    this.ItemModel.ItemCategoryID = obj.ItemCategoryID;
    this.ItemModel.PurchasePrice = obj.PurchasePrice;
    this.ItemModel.SalePrice = obj.SalePrice;
    this.ItemModel.MinQty = obj.MinQty;
    this.ItemModel.MaxQty = obj.MaxQty;
    this.ItemModel.AvailableQty = obj.AvailableQty;
    this.ItemModel.OpenningQty = obj.OpenningQty;
    this.ItemModel.IsActive = obj.IsActive;

};
InventoryCategoryList:any;
GetInventoryCategory  () {
    this.lookupService.GetLookupsList('StockInventoryCategory', '').subscribe( (data)=> {
        this.InventoryCategoryList = data.LookupItems;
    });
};
InventoryItemCategoryList:any;
BindInventoryItemCategory  () {
    var item = {
        ItemId: this.ItemModel.InventoryCategoryID
    }
    this.lookupService.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe( (data)=> {
        this.InventoryItemCategoryList = data.LookupItems;
    });
}
FilterInventoryItemCategoryList:any;
FilterInventoryItemCategory  () {
    var item = {
        ItemId: this.FilterModel.InventoryCategoryID
    }
    this.lookupService.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe( (data)=> {
        this.FilterInventoryItemCategoryList = data.LookupItems;
    });
}
 ValidateDropdown() {
    return this.ItemModel.InventoryCategoryID == 0 || this.ItemModel.ItemCategoryID == 0 ;
};

loading = false;
AlertItem = '';
AlertCode = '';
ItemList=[];
SaveInventoryItem  (valid) {
    this.Submitted = true;
    this.AlertItem = '';
    this.AlertCode = '';
    for (var i = 0; i < this.ItemList.length; i++) {
        if (this.ItemList[i].ItemName == this.ItemModel.ItemName && this.ItemList[i].ItemID != this.ItemModel.ItemID) {
            this.AlertItem = ' Item Name Already Exists ';
            return false
        }
        else if(this.ItemList[i].ItemCode == this.ItemModel.ItemCode && this.ItemList[i].ItemID != this.ItemModel.ItemID) {
            this.AlertCode = ' Item Code Already Exists ';
            return false
        }
    }
    if (valid && !this.ValidateDropdown()) {
        this.loading = true;
        this.spinnerService.show();
         this.stockService.SaveInventoryItem(JSON.stringify(this.ItemModel)).subscribe( (response)=> {
           
               this.spinnerService.hide();
                this.loading = false;
          
            this.GetAllItem();
             this.globalHelper.CheckActionStatus(response);
            if (response.webResponse.Status && this.ItemModel.ItemID == 0) {
                this.Clear();
            }
           
        });
    }
};
GetAllItem  () {
  
    this.FilterModel.CurrentIndex = this.currentPage;
    this.FilterModel.PageSize = this.pageSize;
    this.spinnerService.hide();
     this.stockService.GetAllItem(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
        this.ItemList = data.ItemList;
       this.spinnerService.hide();
        this.recordCount = 0;
        if (this.ItemList != null && this.ItemList.length > 0) {
            this.recordCount = this.ItemList[0].RecordCount;
        }
        this.numberOfPages();
        
    });
};
InventoryItemMarkActive  (item) {

    this.ItemModel.ItemID = item.ItemID;
    this.ItemModel.IsActive = item.IsActive == true ? false : true;
     this.stockService.InventoryItemMarkActive(JSON.stringify(this.ItemModel)).subscribe( (response)=> {
         this.globalHelper.CheckActionStatus(response);
        if (response.webResponse.Status) {
            this.GetAllItem();
        }
    });
}

DownloadItemList:any;
XLSDownload  () {
    
    
    this.FilterModel.CurrentIndex = this.currentPage;
    this.FilterModel.PageSize = this.pageSize;
    this.spinnerService.hide();
     this.stockService.GetAllItem(JSON.stringify(this.FilterModel)).subscribe( (data)=> {           
            
        this.DownloadItemList = data.ItemList;
        if (this.DownloadItemList != null) {
            this.JSONToCsvConverterList(this.DownloadItemList, 'Item_List', true);
        }
        
       this.spinnerService.hide();
    });


}

 JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Sr. No.' + ',';
        row += 'Inventory Category' + ',';
        row += 'Item Category' + ',';
        row += 'Item Code' + ',';
        row += 'Item Name' + ',';
        row += 'Min Qty' + ',';
        row += 'Max Qty' + ',';
        row += 'Current Stock' + ',';
        row += 'Purchase Price' + ',';
        row += 'Sale Price' + ',';
        row += 'Brand Name' + ',';
        row += 'Model Name' + ',';
        row += 'Description' + ',';
        row += 'Active' + ',';
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
        var sno = i + 1;
        var row = "";
        row += '"' + sno + '",';
        if (arrayData[i].CategoryName != null) {
            row += '"' + arrayData[i].CategoryName + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].ItemCategory != null) {
            row += '"' + arrayData[i].ItemCategory + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].ItemCode != null) {
            row += '"' + arrayData[i].ItemCode + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].ItemName != null) {
            row += '"' + arrayData[i].ItemName + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].MinQty != null) {
            row += '"' + arrayData[i].MinQty + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].MaxQty != null) {
            row += '"' + arrayData[i].MaxQty + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].AvailableQty != null) {
            row += '"' + arrayData[i].AvailableQty + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].PurchasePrice != null) {
            row += '"' + arrayData[i].PurchasePrice + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].SalePrice != null) {
            row += '"' + arrayData[i].SalePrice + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].BrandName != null) {
            row += '"' + arrayData[i].BrandName + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].ModelName != null) {
            row += '"' + arrayData[i].ModelName + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].Description != null) {
            row += '"' + arrayData[i].Description + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].IsActive == true) {
            row += '"' + 'Yes' + '",';
        }
        else {
            row += '"' + 'No' + '",';
        }
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
    }
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');
    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}
  ngOnInit() {
    this.GetInventoryCategory();
    this.GetAllItem();
  }

}
